import { Zap, Gem, Smartphone, Rocket, MessageCircle, IndianRupee } from "lucide-react";

const ITEMS = [
  [Zap, "Live in 24 Hours"],
  [Gem, "Premium Design"],
  [Smartphone, "Mobile First"],
  [Rocket, "Fast Performance"],
  [MessageCircle, "WhatsApp Ready"],
  [IndianRupee, "Affordable Pricing"],
];

export const TrustMarquee = () => (
  <section data-testid="trust-strip" className="marquee-paused relative overflow-hidden border-y border-white/10 bg-obsidian py-6">
    <div className="marquee-track flex w-max animate-marquee items-center gap-16 pr-16">
      {[...ITEMS, ...ITEMS, ...ITEMS].map(([Icon, label], i) => (
        <div key={i} className="flex items-center gap-3 whitespace-nowrap">
          <Icon className="h-4 w-4 text-accent" strokeWidth={1.5} />
          <span className="font-display text-xs font-bold uppercase tracking-[0.25em] text-zinc-400">
            {label}
          </span>
          <span className="ml-12 h-1 w-1 rounded-full bg-zinc-700" />
        </div>
      ))}
    </div>
  </section>
);
